import React from 'react';
import { LazyIssueApp } from '@jira/issue__lazy-app/src/LazyIssueApp.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import type NextGenBoardType from '@jira/spa-apps__next-gen-board/src/BoardSPAApp.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { getIssueViewResources } from '@jira/router-resources__issue-view/src/getIssueViewResources.tsx';
import { softwareNextgenRedirectRoute } from '@jira/router-routes__next-gen-routes/src/softwareNextgenRedirectRoute.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
import { softwareProjectLayout } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import { Redirect, type Route, type RouteContext } from '@atlassian/react-resource-router';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { pickNextGenView } from './ui/next-gen/index.tsx';

const SoftwareNextgenRedirectComponent = ({ location }: RouteContext) => (
	<Redirect to={pickNextGenView(location)} />
);

const LazyBoardPage = lazyForPaint<typeof NextGenBoardType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-next-gen-board", jiraSpaEntry: "next-gen-board" */ '@jira/spa-apps__next-gen-board/src/BoardSPAApp.tsx'
		),
	),
);

export const softwareNextgenRedirectRouteEntry: Route = createEntry(
	softwareNextgenRedirectRoute,
	() => ({
		group: 'software',
		// eslint-disable-next-line no-restricted-syntax
		component: SoftwareNextgenRedirectComponent,
		layout: softwareProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			horizontal: AsyncHorizontalNavJira,
		},

		resources: [...getNavigationResources(), ...getIssueViewResources()],
		afterPaint: [LazyIssueApp],
		forPaint: [LazyAtlassianNavigation, LazyBoardPage],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
